/**
 * お気に入り（ハート）→ アプリ API 連動
 * - ページ読込時に自分のお気に入りを取得し、該当ハートを active 表示にする
 * - クリックで即座に見た目を反映（楽観的更新）→ 裏で App Proxy にトグル送信
 *   ※ App Proxy(Shopify→Vercel→Supabase) の往復を待つと体感ラグになるため、
 *     先に見た目を変え、失敗時のみ元に戻す。
 * - 未ログイン(401)時はログイン画面へ誘導
 * data 属性: data-favorite data-product-id [data-handle data-title data-image data-label-on]
 */
(function () {
  var API = '/apps/quote/api/favorites';

  function allButtons() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-favorite]'));
  }

  // 見た目（active クラス・aria-pressed・PDPの文言）を状態に合わせる
  function setState(btn, on) {
    btn.classList.toggle('is-favorited', !!on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var span = btn.querySelector('span');
    var labelOn = btn.getAttribute('data-label-on');
    if (span && labelOn) {
      if (!btn.getAttribute('data-label-off')) {
        btn.setAttribute('data-label-off', span.textContent);
      }
      span.textContent = on ? labelOn : btn.getAttribute('data-label-off');
    }
  }

  // --- ハイドレート: 現在のお気に入りをハートに反映 ---
  var favSet = null; // 取得済みのお気に入りID集合（動的に増えたカードにも同じ結果を当てる）
  function applyState() {
    if (!favSet) return;
    allButtons().forEach(function (btn) {
      if (favSet[String(btn.getAttribute('data-product-id'))]) setState(btn, true);
    });
  }
  fetch(API, { credentials: 'same-origin' })
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (data) {
      if (!data || !data.ids) return;
      favSet = {};
      data.ids.forEach(function (id) { favSet[String(id)] = true; });
      applyState();
    })
    .catch(function () { /* 未ログイン等は無視 */ });
  // CB260917 B2: 商品一覧の「安い順」がカードを取り寄せて差し替えた後に状態を再反映
  document.addEventListener('asplund:cards-updated', applyState);

  // --- クリックでトグル（楽観的更新・イベント委譲で動的カードにも対応） ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-favorite]') : null;
    if (!btn) return;
    e.preventDefault();

    var productId = btn.getAttribute('data-product-id');
    if (!productId || btn.getAttribute('data-fav-busy')) return;
    btn.setAttribute('data-fav-busy', '1');

    // 1) まず見た目を即反映（ラグ解消）
    var target = !btn.classList.contains('is-favorited');
    setState(btn, target);

    // 2) 裏でサーバーに反映
    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        product_id: productId,
        handle: btn.getAttribute('data-handle') || '',
        title: btn.getAttribute('data-title') || '',
        image_url: btn.getAttribute('data-image') || ''
      })
    })
      .then(function (res) {
        // 未ログイン→ログイン後に今のページへ戻す（/account/login は return_to を捨てるので使わない）
        if (res.status === 401) { window.location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search); return null; }
        return res.json().then(function (d) { return { ok: res.ok, d: d }; });
      })
      .then(function (r) {
        if (!r) return;                      // 401でログインへ遷移中
        // 会員情報が未登録（403 profile_required）→元に戻して登録画面へ（西澤さん 2026-10-08）
        if (r.d && r.d.profile_required) {
          setState(btn, !target);
          if (window.aspGoProfileRegister) window.aspGoProfileRegister();
          else window.location.href = '/apps/quote/profile?first=1&return_to=' + encodeURIComponent(location.pathname + location.search);
          return;
        }
        if (!r.ok) { setState(btn, !target); return; } // 失敗→元に戻す
        setState(btn, !!r.d.favorited);      // サーバーの確定値に整合
      })
      .catch(function () { setState(btn, !target); }) // 通信失敗→元に戻す
      .then(function () { btn.removeAttribute('data-fav-busy'); });
  });
})();
